export interface PageTimeInfo {
  pageHashedId: string;
  pageIndex: number;
  startTime: number;
  duration: number;
}

export interface TemplateSubmissionFlowInfo {
  selectedPosterHashedId: string;
  selectedPosterPreviewUrl: string;
  posterColor: string;
  posterType: string;
  designerProfileUri: string;
  templateName: string;
  currentPreviewTimestamp?: number;
  pagesTimeInfo: PageTimeInfo[];
  isTemplateAiTaggingEnabled: boolean;
}

export interface TemplateSubmissionFlowReducerState extends TemplateSubmissionFlowInfo {
  currentStep: SubmissionFlowStep;
  nextStep: SubmissionFlowStep;
  templateTags: string[];
  isTermsAndConditionsSelected: boolean;
  isAcknowledgementSelected: boolean;
  isSubmitting: boolean;
  templateNameInput: string;
  selectedTemplateNameSuggestionPill: string;
  isAITemplateNameGenerating: boolean;
  isFieldsErrorState?: boolean;
}

export enum SubmissionFlowStep {
  DETAILS = 1,
  IN_REVIEW = 2
}

export interface TemplateSubmissionFlowContainerQuery {
  isMobileScreen?: boolean;
  isTabletScreen?: boolean;
  isLaptopScreen?: boolean;
  isDesktopScreen?: boolean;
}

export interface TemplateSubmissionData {
  templateName: string;
  templateTags: string[];
  isTermsAndConditionsSelected: boolean;
  isAcknowledgementSelected: boolean;
  selectedPosterHashedId: string;
  currentPreviewTimestamp?: number;
}